var ScrollReveal = require("scrollreveal");

window.ScrollRevealInstance = null;

$(document).ready(function(){
	var ie = (function(){
		var undef,
			v = 3,
			div = document.createElement('div'),
			all = div.getElementsByTagName('i');
		while (
			div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
			all[0]
		);
		return v > 4 ? v : undef;
	}());

	if(window.screen.availWidth>640)
	{
		if(ie == undefined){
			window.ScrollRevealInstance = ScrollReveal({
			scale: 1,
			delay: 0,
			duration:1200,
			viewFactor: 0.25,
			easing: 'ease',
			afterReveal: function (domEl) {
					$(domEl).css('transform', 'none');
					$(domEl).find('.toAnimate').addClass('animated');
					$(domEl).find('.toAnimate').removeClass('toAnimate');
				},
			});

			$('[animation]').each(function(){
				let origin = $(this).attr('animation');
				let distance = $(this).attr('animation-distance'); distance = distance ? distance : 100;
				let delay = $(this).attr('animation-delay'); delay = delay ? delay : 0;
				let duration = $(this).attr('animation-duration'); duration = duration ? duration : 1000;
				let reset = $(this).attr('animation-reset'); reset = reset ? reset : false;

				window.ScrollRevealInstance.reveal(this, {
					origin: origin,
					distance: distance+'px',
					delay:delay,
					duration:duration,
					reset:reset
				});
			})
		}
	}
});